import { render, staticRenderFns } from "./claimsList.vue?vue&type=template&id=26143ee6&scoped=true&"
import script from "./claimsList.vue?vue&type=script&lang=js&"
export * from "./claimsList.vue?vue&type=script&lang=js&"
import style0 from "./claimsList.vue?vue&type=style&index=0&id=26143ee6&lang=scss&scoped=true&"
import style1 from "./claimsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26143ee6",
  null
  
)

export default component.exports